import script from "./purchaser-details.vue?vue&type=script&lang=ts&setup=true"
export * from "./purchaser-details.vue?vue&type=script&lang=ts&setup=true"

import "./purchaser-details.vue?vue&type=style&index=0&id=9a5319a0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a5319a0"]])

export default __exports__